// Couleurs appliquées par le JavaScript (plateforme, boutique), gardées sur l'appareil pour que
// index.html les réapplique avant le premier affichage du chargement suivant.
// Format lu par le script de index.html : { id du <style>, variables CSS, règles CSS }.
export function rememberBootColors(key, styleId, varNames, css) {
    try {
        const root = document.documentElement;
        const vars = Object.fromEntries(varNames.map(name => [name, root.style.getPropertyValue(name)]).filter(([, value]) => value));
        if (!css && !Object.keys(vars).length) {
            localStorage.removeItem(key);
            return;
        }
        localStorage.setItem(key, JSON.stringify({ id: styleId, vars, css }));
    } catch (e) { /* stockage indisponible */ }
}
